import { render } from "./ViewProfile.vue?vue&type=template&id=6495f8a9&scoped=true"
import script from "./ViewProfile.vue?vue&type=script&lang=js"
export * from "./ViewProfile.vue?vue&type=script&lang=js"

import "@/Common/Styles/profile.scss?vue&type=style&index=0&id=6495f8a9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6495f8a9"]])

export default __exports__